import React, { createContext, useContext, useEffect, useState } from 'react';
import Api from '../utils/api';

// Creamos el contexto para el TokenProvider
const AuthContext = createContext();

// El proveedor que se utilizará en la parte superior de la jerarquía de componentes
export const AuthProvider = ({ children }) => {


  const [authData, setAuthData] = useState({
    token: localStorage.getItem('token') || null,
    userData: JSON.parse(localStorage.getItem('userData')) || null,
  });


  useEffect(() => {
    Api.authToken = authData.token
  }, [authData])

  // Función para actualizar el token y los datos del usuario
  const updateAuthData = (newToken, newUserData) => {
    setAuthData({
      token: newToken,
      userData: newUserData,
    });
    localStorage.setItem('token', newToken);
    localStorage.setItem('userData', JSON.stringify(newUserData));
  };

  // Función para limpiar el token y los datos del usuario
  const clearAuthData = () => {
    setAuthData({
      token: null,
      userData: null,
    });
    localStorage.removeItem('token');
    localStorage.removeItem('userData');
  };

  Api.authToken = authData.token



  return (
    <AuthContext.Provider value={{ authData, updateAuthData, clearAuthData }}>
      { children}
    </AuthContext.Provider>
  );
};

// Hook personalizado para acceder al contexto de autenticación
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth debe ser utilizado dentro de un AuthProvider');
  }
  return context;
};
